export function getExtension (filename = '') {
  return filename ? filename.split('.').pop() : ''
}
